import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useQuery } from '@apollo/client';
import { FORM_VALUES } from '../../../../../utils/helpers/constants';
import { setCitiesList, setError } from '../../../../../actions';
import { SelectProps } from '../types';
import { LocationsSelect } from '../LocationsSelect';
import { cityQuery, getAllCities } from '../../../../../api/queries';

interface CitiesSelectProps extends SelectProps {
  setCitiesLoading: Dispatch<SetStateAction<boolean>>;
}

export const CitiesSelect: React.FC<CitiesSelectProps> = ({
  setCitiesLoading,
  setInitCoordinates,
  setShouldRenderMap
}) => {
  const { t } = useTranslation();
  const { change } = useForm();
  const dispatch = useDispatch();
  const { values } = useFormState();

  const formValueCity = values[FORM_VALUES.cityId];
  const cityId = { id: formValueCity };

  const { data, loading, error } = useQuery(cityQuery, {
    variables: cityId
  });
  const {
    data: allCities,
    loading: allCitiesLoading,
    error: allCitiesError
  } = useQuery(getAllCities);

  const allCitiesData = (allCities && allCities.cities) || [];

  useEffect(() => {
    dispatch(setCitiesList(allCitiesData));
  }, [allCitiesData]);

  useEffect(() => {
    if (data?.city) {
      change('cityHasLocations', !!data?.city?.locations.length);
      setInitCoordinates({
        lat: data?.city?.latitude,
        lng: data?.city?.longitude
      });
    }
  }, [data?.city]);

  useEffect(() => {
    if (error || allCitiesError) dispatch(setError(true));
  }, [error, allCitiesError]);

  useEffect(() => {
    setCitiesLoading(loading);
  }, [loading]);

  const onChangeRadioHandler = (e?: React.ChangeEvent<HTMLInputElement>) => {
    const newCityId = e?.target.value;
    change(FORM_VALUES.cityId, newCityId);
    change(FORM_VALUES.locationId, undefined);
    change(FORM_VALUES.locationName, undefined);
    setShouldRenderMap(false);
    change(FORM_VALUES.coordinates, '');
  };

  const selectAndModalCypress = 'item-form-city';
  const selectTitleAndPlaceholder = `${t('search.city_search.title')} *`;
  const cityName = data && data.city != null ? data.city.name : '';

  return (
    <LocationsSelect
      loading={loading || allCitiesLoading}
      inputStat="item-form-find-city"
      inputPlaceholder={t('new_search.search_city_placeholder')}
      selectCypress={selectAndModalCypress}
      modalCypress={selectAndModalCypress}
      selectTitleAndPlaceholder={selectTitleAndPlaceholder}
      selectValue={cityName}
      contentContainerCypress="item-form-city__container"
      radioCypress="city"
      radioName="search-city"
      currentValue={formValueCity}
      data={allCitiesData}
      fieldName={FORM_VALUES.cityId}
      errorCypress="city-id-field-error"
      onSelect={onChangeRadioHandler}
    />
  );
};
